var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
function Video(_a) {
    var src = _a.src, _b = _a.title, title = _b === void 0 ? 'Vimeo Video Player' : _b, className = _a.className;
    return (_jsx("div", __assign({ className: clsx('w-full h-full', className) }, { children: _jsx("iframe", { allow: "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share", className: "rounded-lg aspect-video vimeo-embed-iframe", referrerPolicy: "strict-origin-when-cross-origin", src: src, title: title, width: "100%", allowFullScreen: true }) })));
}
export default Video;
